import { IConfirmPublicationRequest } from "../../../../model/official-daily/request/confirm-publication-request";
import { IPreviewPublicationRequest } from "../../../../model/official-daily/request/preview-publication-request";
import { ICategoryPublicationResponse } from "../../../../model/official-daily/response/category-publication-response";
import { IEntityPublicationResponse } from "../../../../model/official-daily/response/entity-publication-response";
import { IListDocumentTypesResponse } from "../../../../model/official-daily/response/list-document-types-response";
import { IPreviewPublicationResponse } from "../../../../model/official-daily/response/preview-publication-response";
import { ISubCategoryPublicationResponse } from "../../../../model/official-daily/response/subcategory-publication-response";


export type PublicacaoDiarioOficialState = {
    activeStep: number;
    tabIndexForm: number;
    tabIndePreview: number;
    previewPublicationRequest: IPreviewPublicationRequest;
    subCategoryPublicationResponse: ISubCategoryPublicationResponse[];
    categoryPublicationResponse: ICategoryPublicationResponse[];
    listDocumentTypesResponse: IListDocumentTypesResponse[];
    entityPublicationResponse: IEntityPublicationResponse[];
    previewPublicationResponse: IPreviewPublicationResponse;
    completed: { [k: number]: boolean; };
    files: File[];
};

export enum ACTION_TYPES {
    setActiveStep = 'setActiveStep',
    setPreviewPublicationRequest = 'setPreviewPublicationRequest',
    setSubCategoryPublicationResponse = 'setSubCategoryPublicationResponse',
    setEntityPublicationResponse = 'setEntityPublicationResponse',
    setPreviewPublicationResponse = 'setPreviewPublicationResponse',
    setCompleted = 'setCompleted',
    setCategoryPublicationResponse = 'setCategoryPublicationResponse',
    setFiles = 'setFiles',
    setListDocumentTypesResponse = 'setListDocumentTypesResponse',
    setTabIndexForm = 'setTabIndexForm',
    setTabIndexPreview = 'setTabIndexPreview',
}

export const PublicacaoDiarioOficialReducer = (state: PublicacaoDiarioOficialState, action: any): PublicacaoDiarioOficialState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setActiveStep:
            return {
                ...state,
                activeStep: payload,
            };
        case ACTION_TYPES.setPreviewPublicationRequest:
            return {
                ...state,
                previewPublicationRequest: payload,
            };
        case ACTION_TYPES.setPreviewPublicationResponse:
            return {
                ...state,
                previewPublicationResponse: payload,
            };
        case ACTION_TYPES.setCompleted:
            return {
                ...state,
                completed: payload,
            };
        case ACTION_TYPES.setFiles:
            return {
                ...state,
                files: payload,
            };
        case ACTION_TYPES.setSubCategoryPublicationResponse:
            return {
                ...state,
                subCategoryPublicationResponse: payload,
            };
        case ACTION_TYPES.setCategoryPublicationResponse:
            return {
                ...state,
                categoryPublicationResponse: payload,
            };
        case ACTION_TYPES.setEntityPublicationResponse:
            return {
                ...state,
                entityPublicationResponse: payload,
            };
        case ACTION_TYPES.setListDocumentTypesResponse:
            return {
                ...state,
                listDocumentTypesResponse: payload,
            };
        case ACTION_TYPES.setTabIndexForm:
            return {
                ...state,
                tabIndexForm: payload,
            };
        case ACTION_TYPES.setTabIndexPreview:
            return {
                ...state,
                tabIndePreview: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}